import React, { forwardRef } from 'react'
import '../../styles/index.scss'
import { dataFunction } from '../../data/data-intro';
import './Function.scss'
import beauti from '../../assets/images/function/beauti.png'
import anti from '../../assets/images/function/anti.png'
import gentle from '../../assets/images/function/gentle.png'
import ease from '../../assets/images/function/ease.png'
import eco from '../../assets/images/function/eco.png'
import PropTypes from 'prop-types'

const FunctionPageMobile = (props, ref) => {
    const { isMobile } = props

    const contentAntiMobile = () => (
        <>
            <div className="bg-anti">
                <div className='functionNP-mobile-cover-content-rv bg-anti-div'>
                    <div className='functionNP-mobile-cover-content-item'>
                        <img loading="lazy" src={anti} alt="anti" />
                    </div>
                    <div className={`functionNP-mobile-cover-content-item ${!isMobile ? `` : `container`}`}>
                        <p>
                            {dataFunction.content2}
                        </p>
                    </div>
                </div>
            </div>

            <div className="bg-anti2">
                <div className='functionNP-mobile-cover-content bg-anti-div-padding'>
                    <div className='functionNP-mobile-cover-content-item'>
                        <img loading="lazy" src={gentle} alt="gentle" />
                    </div>
                    <div className={`functionNP-mobile-cover-content-item ${!isMobile ? `` : `container`}`}>
                        <p>
                            {dataFunction.content3}
                        </p>
                    </div>
                </div>
            </div>
        </>
    )


    const contentAnti = () => (
        <div className="bg-anti">
            <div className='container'>
                <div className='functionNP-mobile-cover-content-rv bg-anti-div'>
                    <div className='functionNP-mobile-cover-content-item'>
                        <img loading="lazy" src={anti} alt="anti" />
                    </div>
                    <div className={`functionNP-mobile-cover-content-item ${!isMobile ? `` : `container`}`}>
                        <p>
                            {dataFunction.content2}
                        </p>
                    </div>
                </div>

                <div className='functionNP-mobile-cover-content bg-anti-div-padding'>
                    <div className='functionNP-mobile-cover-content-item'>
                        <img loading="lazy" src={gentle} alt="gentle" />
                    </div>
                    <div className={`functionNP-mobile-cover-content-item ${!isMobile ? `` : `container`}`}>
                        <p>
                            {dataFunction.content3}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
    return (
        <>
            <div className='functionNP-mobile'>
                <div className="">
                    <div className='functionNP-mobile-title' ref={ref}>
                        {dataFunction.title}
                    </div>
                    <div className='functionNP-mobile-cover-content mt-5 bg-beauti'>
                        <div className={`${isMobile ? `` : `container`}`}>
                            <div className='functionNP-mobile-cover-content-item bg-beauti-div'>
                                <img loading="lazy" src={beauti} alt="beauti" />
                            </div>
                            <div className={`functionNP-mobile-cover-content-item ${!isMobile ? `` : `container`}`}>
                                <p>
                                    {dataFunction.content1}
                                </p>
                            </div>
                        </div>


                    </div>
                    {
                        isMobile ? contentAntiMobile() : contentAnti()
                    }


                    <div className="bg-ease">
                        <div className={`${isMobile ? `` : `container`}`}>
                            <div className='functionNP-mobile-cover-content-rv pt-80'>
                                <div className='functionNP-mobile-cover-content-item item-img-padding'>
                                    <img loading="lazy" src={ease} alt="ease" />
                                </div>
                                <div className={`functionNP-mobile-cover-content-item item-padding ${!isMobile ? `` : `container`}`}>
                                    <div className="pt-50 special padding-class">
                                        <p>   {dataFunction.content4}</p>
                                        <p className="pt-30"> {dataFunction.content4x}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="bg-eco">
                        <div className={`${isMobile ? `` : `container`}`}>
                            <div className='functionNP-mobile-cover-content pt-80'>
                                <div className='functionNP-mobile-cover-content-item'>
                                    <img loading="lazy" src={eco} alt="eco" />
                                </div>
                                <div className={`functionNP-mobile-cover-content-item ${!isMobile ? `` : `container`}`}>
                                    <div className="pt-30 special">
                                        <p>{dataFunction.content5}</p>
                                        <p className="pt-30">  {dataFunction.content6}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

            </div>


        </>
    )

}

export default forwardRef(FunctionPageMobile)

FunctionPageMobile.propTypes = {
    isMobile: PropTypes.bool
}